import { useAuth } from '@/lib/AuthContext'
import type { SetupFieldsProps } from '@/modules/types'
import { RecognitionValuesFields } from './RecognitionValuesFields'
import { RecognitionTypesSettings } from './RecognitionTypesSettings'

/**
 * The Recognition space's settings: the community values (wizard and edit)
 * and, in the space edit only, F-185 "Tipos e artes" for owner/admin. The
 * kinds save on their own endpoints at once, so they stay out of the wizard,
 * where nothing is saved before "Criar". The API answers 403 to anyone else.
 */
export const RecognitionSetupFields = ({ config, onChange, errors, disabled, context }: SetupFieldsProps) => {
  const { hasRole } = useAuth()
  return (
    <div className="min-w-0 space-y-5">
      <RecognitionValuesFields config={config} onChange={onChange} errors={errors} disabled={disabled} />
      {context === 'edit' && hasRole(['owner', 'admin']) && <RecognitionTypesSettings />}
    </div>
  )
}
